import { render } from "./TeachersListGradeLevel.vue?vue&type=template&id=62b3a456"
import script from "./TeachersListGradeLevel.vue?vue&type=script&lang=js"
export * from "./TeachersListGradeLevel.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__